import React, { useMemo } from "react";
import { useU2000AuthContext } from "../../../u2000Core/context/auth/U2000UseAuthContext";
import { useU2000TimesheetWeekView } from "../../../u2000Core/hooks/useU2000TimesheetWeekView";
import { NS } from "../../U3130";
import { U3130TimesheetWeekViewContext } from "./useU3130TimesheetWeekView";

type U3130TimesheetWeekViewProviderProps = {
  periodDate: string | undefined | null;
  children: React.ReactNode;
};

/** Vue semaine partagée par les onglets du détail (case samedi / dimanche unique, comme U3129). */
export function U3130TimesheetWeekViewProvider({ periodDate, children }: U3130TimesheetWeekViewProviderProps) {
  const { auth } = useU2000AuthContext();
  const weekendToggleStorageKey = useMemo(
    () =>
      auth.isAuthenticated && auth.user.userName
        ? `U3130_${auth.user.userName}_${auth.user.organizationId || "noorg"}ShowWeekendDays`
        : "U3130ShowWeekendDays",
    [auth.isAuthenticated, auth.user.organizationId, auth.user.userName],
  );
  const weekView = useU2000TimesheetWeekView(periodDate, NS, weekendToggleStorageKey);
  return <U3130TimesheetWeekViewContext.Provider value={weekView}>{children}</U3130TimesheetWeekViewContext.Provider>;
}
